var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBocachica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 86,
    viewBox: "0 0 133 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 483242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5458 28.7795C14.5458 24.4953 18.0332 21.0222 22.335 21.0222H39.2116V26.1937C39.2116 28.1805 38.4616 29.9928 37.2282 31.3652C38.4616 32.7376 39.2116 34.55 39.2116 36.5367V41.7082L14.5458 41.7082V28.7795ZM34.0188 26.1937L22.335 26.1937C20.9011 26.1937 19.7386 27.3514 19.7386 28.7795L19.7386 36.5367H34.0188C34.0188 35.1095 32.8577 33.9524 31.425 33.951H22.335V28.7795L31.4224 28.7795C32.8564 28.7795 34.0188 27.6218 34.0188 26.1937Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5986 21.0222C45.2967 21.0222 41.8094 24.4953 41.8094 28.7795V41.7082L58.686 41.7082C62.9878 41.7082 66.4752 38.2352 66.4752 33.951V21.0222H49.5986ZM61.2824 26.1937L49.5986 26.1937C48.1646 26.1937 47.0022 27.3514 47.0022 28.7795V36.5367L58.686 36.5367C60.1199 36.5367 61.2824 35.3791 61.2824 33.951L61.2824 26.1937Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8575 21.0222C72.5556 21.0222 69.0683 24.4953 69.0683 28.7795V41.7082L93.7341 41.7082V36.5367L74.2611 36.5367V28.7795C74.2611 27.3514 75.4235 26.1937 76.8575 26.1937L93.7341 26.1937V21.0222H76.8575Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0521 41.7082L100.795 26.1091C101.92 23.0536 104.841 21.0222 108.108 21.0222H111.24C114.508 21.0222 117.428 23.0535 118.553 26.1089L124.297 41.7082H118.766L116.862 36.5368H102.534V36.4091L100.583 41.7082H95.0521ZM114.958 31.3653L113.678 27.8893C113.303 26.8708 112.329 26.1937 111.24 26.1937L108.108 26.1937C107.019 26.1937 106.046 26.8708 105.671 27.8893L104.391 31.3653H114.958Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8063 64.9778L104.549 49.3786C105.674 46.3231 108.595 44.2917 111.862 44.2917H114.994C118.262 44.2917 121.182 46.323 122.307 49.3785L128.051 64.9778H122.52L120.616 59.8063H106.288V59.6786L104.337 64.9778H98.8063ZM118.712 54.6348L117.432 51.1588C117.057 50.1403 116.084 49.4632 114.994 49.4632H111.862C110.773 49.4632 109.8 50.1404 109.425 51.1589L108.145 54.6348H118.712Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7805 64.9778V44.2917H42.9733V52.049H57.2534V44.2917H62.4462V64.9778H57.2535V57.2205H42.9733V64.9778H37.7805Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2329 44.2917V64.9778H65.0401V44.2917H70.2329Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3068 44.2917C14.0049 44.2917 10.5176 47.7648 10.5176 52.049V64.9778L35.1833 64.9778V59.8063H15.7104V52.049C15.7104 50.6209 16.8728 49.4632 18.3068 49.4632H35.1833V44.2917H18.3068Z",
    fill: "#A2A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6203 44.2917C76.3185 44.2917 72.8311 47.7648 72.8311 52.049V64.9778L97.4969 64.9778V59.8063H78.0239V52.049C78.0239 50.6209 79.1864 49.4632 80.6203 49.4632H97.4969V44.2917H80.6203Z",
    fill: "#A2A2AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBocachica);
export default __webpack_public_path__ + "static/media/bocachica.ffce2c8f17ec81ebec20130f891b3da8.svg";
export { ForwardRef as ReactComponent };